// extracted by mini-css-extract-plugin
module.exports = {"handle":"SwipeHandle_handle__RflJP"};